export default __webpack_public_path__ + "static/media/chantilly3.9b8a6832.jpg";